import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const getHomePageData = (req) => {
    try {
        const response = axiosInstance.get(API_URLS.homepagedata, { params: req })
        return response
    }
    catch (e) {
        throw new Error(e);
    }
}